import { DownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { foundationColors } from "../../../../../../../themes/colors";
import ExportBusinessAssetsModal from "./ExportBusinessAssetsModal";

type ExportBusinessAssetsButtonProps = {
  email: string;
  taxYear: number;
};

const ExportBusinessAssetsButton = ({
  email,
  taxYear,
}: ExportBusinessAssetsButtonProps) => {
  const { t } = useTranslation("BusinessAssetExport");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const showModal = () => setIsModalOpen(true);
  const hideModal = () => setIsModalOpen(false);

  return (
    <>
      <Button
        icon={<DownloadOutlined />}
        style={{
          display: "inline-flex",
          ...(isHovered && {
            borderColor: foundationColors["coral-900-base"],
            color: foundationColors["coral-900-base"],
          }),
        }}
        data-test="downloadBusinessAssetsButton"
        onClick={showModal}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {t("download")}
      </Button>
      <ExportBusinessAssetsModal
        open={isModalOpen}
        onClose={hideModal}
        email={email}
        taxYear={taxYear}
      />
    </>
  );
};

export default ExportBusinessAssetsButton;
